module.exports = __webpack_public_path__ + "static/media/facebook.8454f694.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/facebook.svg
// module id = 51
// module chunks = 0